import { Breadcrumbs, BreadcrumbsProps, Link } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import homeIcon from '../../assets/svgs/icons/home-icon-white.svg';
import { getPageContext } from '../../utils/getPageContext';
import { getPageText } from '../../utils/getPageText';
import DefaultText from '../typography/default-text';
import { sxBreadCrumbs } from './sxProps';

interface Props extends BreadcrumbsProps {
}

const Breadcrumb: React.FC<Props> = ({ ...props }) => {

	const location = useLocation();

	const [pageContextText, setPageContext] = useState<string>('');
	const [pageNameText, setPageName] = useState<string>('');

	useEffect(() => {
		const segments = location.pathname.split('/').filter(Boolean);
		const pageContext = segments[0] || '';
		const pageName = segments[1] || '';
		const formattedPageContext = getPageContext(pageContext);
		const formattedPageName = getPageText(pageName);
		setPageContext(formattedPageContext);
		setPageName(formattedPageName);
	}, [location]);

	return (
		<Breadcrumbs aria-label="breadcrumb" sx={sxBreadCrumbs} separator={<DefaultText color="var(--primary-white)" size="xs" bold>/</DefaultText>}>
			<Link
				underline="none"
				sx={{ display: 'flex', alignItems: 'center' }}
				color="var(--primary-white)"
				href="/"
			>
				<img src={homeIcon} alt="Ícone Home (Voltar para o início)" width={'24px'} height={'24px'} className='hover-07' />
			</Link>
			<Link
				underline="none"
				sx={{ display: 'flex', alignItems: 'center' }}
				color="var(--secondary-medium-grey)"
			>
				{pageContextText}
			</Link>
			{pageNameText &&
				<Link
					underline='none'
					sx={{ display: 'flex', alignItems: 'center' }}
					color="var(--primary-white)"
				>
					{pageNameText}
				</Link>
			}
		</Breadcrumbs>
	)
}

export default Breadcrumb;